import {MemexColumnDataType} from '../api/columns/contracts/memex-column'
import {isValueActionableColumn} from '../models/column-capabilities'
import type {MemexItemModel} from '../models/memex-item-model'

export function columnActionable(item: MemexItemModel, columnType?: MemexColumnDataType) {
  // These column data types are never actionable
  if (columnType === undefined || !isValueActionableColumn(columnType)) {
    return false
  }

  // linked pull requests are only actionable if there is at least one linked PR
  if (columnType === MemexColumnDataType.LinkedPullRequests && item.getLinkedPullRequests().length < 1) {
    return false
  }

  return true
}
